<template>
  <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page" id="app">

    <Loading v-if="$root.loading"></Loading>
    <div v-else class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
         id="kt_content">
      <!-- begin:: Content -->
      <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">

        <div class="kt-portlet" id="sent-portlet">
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <h3 class="kt-portlet__head-title">
                В разработке
              </h3>
            </div>
          </div>

          <div class="kt-portlet__body">
            Данный тип заявки на стадии разработки. Об окончании работ и запуске сообщим отдельно
          </div>

          <div class="kt-portlet__foot">
            <div class="kt-form__actions">
              <router-link :to="{name: 'home'}" class="btn btn-success">
                На главную
              </router-link>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Loading from '../components/Loading';

export default {
  name: 'UnderConstruction',
  components: {
    Loading,
  },
  computed: {
    hasError() {

    },
  },
  mounted() {
    window.BX24.ready(() => {
      window.BX24.init(() => {
        const height = document.getElementById('sent-portlet').clientHeight;
        window.BX24.resizeWindow(
          document.body.clientWidth,
          height + 150,
        );
      });
    });
  },
};
</script>

<style lang="scss">
  #kt_content {
    color: #000;
    font-family: "Roboto", serif;
  }

  .app__portlet-head {
    font-family: "Roboto", serif;
  }

  .kt-portlet__head-title {
    font-family: "Roboto", serif;
  }
</style>
